import { StringParam, NumericArrayParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { ContractorsDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleMap: ColumnTitleSchema<ContractorsDataSource> = {
  code: 'Код подрядчика',
  name: 'Подрядчик',
  login: 'Логин',
  email: 'Электронная почта',
  additionalInfo: 'Дополнительные сведения',
  contacts: 'Контактная информация'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.id]: StringParam,
  [FILTERS_PARAMS_KEYS.contractorIds]: NumericArrayParam
}

export const tableSearchQuerySchema: TableSearchQuerySchema<ContractorsDataSource> = {
  'table-code': StringParam,
  'table-name': StringParam,
  'table-login': StringParam,
  'table-email': StringParam,
  'table-contacts': StringParam,
  'table-additionalInfo': StringParam
} as const

const titleWrapperProps = { minWidth: 200 } as const

export const columnsSearchSchema: ColumnTableSearchSchema<ContractorsDataSource> = {
  code: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps },
  name: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  login: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  email: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  contacts: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  additionalInfo: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps }
}
